import { allStatusesEnum, sapInvoiceStatusesEnum } from '../balance/constants';

export const calculateDebitAmountSum = (bookingEntries = []) => {
  return bookingEntries.reduce((acc, entry) => acc + entry.debitAmount, 0);
};

export const calculateDiscountSum = (bookingEntries = []) => {
  return bookingEntries.reduce((acc, entry) => acc + entry.discount, 0);
};

export const calculateTotalSum = (bookingEntries = []) => {
  return (
    calculateDebitAmountSum(bookingEntries) -
    calculateDiscountSum(bookingEntries)
  );
};

export const applicableDiscount = (budget, bookingEntries) => {
  return calculateTotalSum(bookingEntries) - budget;
};

export const isDiscountApplicable = (budget, bookingEntries) => {
  return applicableDiscount(budget, bookingEntries) > 0;
};

export const statusColor = status => {
  switch (status) {
    case allStatusesEnum.DRAFT.value:
      return 'info';
    case allStatusesEnum.IN_REVIEW.value:
      return 'warning';
    case allStatusesEnum.CHANGES_REQUESTED.value:
      return 'danger';
    case allStatusesEnum.APPROVED.value:
      return 'success';
    case allStatusesEnum.EXPORTED.value:
      return 'secondary';
    case allStatusesEnum.CANCELED.value:
      return 'danger';
    default:
      return 'secondary';
  }
};

export const sapStatusColor = status => {
  switch (status) {
    case sapInvoiceStatusesEnum.ORDER_PENDING.value:
      return 'secondary';
    case sapInvoiceStatusesEnum.ORDER_CREATED.value:
      return 'primary';
    case sapInvoiceStatusesEnum.INVOICED.value:
      return 'success';
    case sapInvoiceStatusesEnum.PAID.value:
      return 'success';
    case sapInvoiceStatusesEnum.INVOICE_REVERSED.value:
      return 'info';
    case sapInvoiceStatusesEnum.BILLING_CONTENT_CANCELED.value:
      return 'warning';
    case sapInvoiceStatusesEnum.BILLING_CONTENT_ERROR.value:
      return 'danger';
    default:
      return 'secondary';
  }
};
